import * as React from 'react'
import { SVGProps } from 'react'

const SvgTwitterIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.7431 12.2661L3 3.6875H8.34101L12.5035 8.98963L16.9504 3.71137H19.892L13.9257 10.8013L21 19.8125H15.6749L11.1678 14.0786L6.35607 19.7966H3.39858L9.7431 12.2661ZM16.4511 18.2231L6.27493 5.27695H7.56424L17.7276 18.2231H16.4511Z'
      fill='#3071EE'
    />
  </svg>
)

export default SvgTwitterIcon
